import { GroupAssignee } from "../Types";
export const isGroupAssignee = (value) => {
    return GroupAssignee.safeParse(value).success;
};
//# sourceMappingURL=isGroupAssignee.js.map